import styled from 'styled-components';

export const NotiBoardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NotiBoardSimple = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-bottom: 1.5px solid #f1f1f1;
  padding: 0 15px;
`;

export const NotiTitle = styled.p`
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 5px;
  text-align: left;
`;

export const NotiDate = styled.p`
  font-size: 11px;
  margin-bottom: 15px;
  text-align: left;
`;
